"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmailStatsReadyMockData = exports.buildMailingFeedbackMockData = exports.buildDesktopCompletionMockData = exports.buildIndividualFundraisingOutreachMockData = exports.buildSatisfactionSurveyMockData = void 0;
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const organization_facing_base_1 = require("./organization-facing-base");
const CAMPAIGN_TYPE_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "event",
    [locales_1.Locales.FR]: "événement",
    [locales_1.Locales.ES]: "evento",
    [locales_1.Locales.DE]: "Veranstaltung",
});
const CAMPAIGN_TYPE_PLURAL_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "events",
    [locales_1.Locales.FR]: "événements",
    [locales_1.Locales.ES]: "eventos",
    [locales_1.Locales.DE]: "Veranstaltungen",
});
const SATISFACTION_SURVEY_SUBJECT_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Quick question about your event Sandbox Gala",
    [locales_1.Locales.FR]: "Comment s'est passé votre événement Sandbox Gala avec Zeffy ?",
    [locales_1.Locales.ES]: "Una pregunta rápida sobre su evento Sandbox Gala",
    [locales_1.Locales.DE]: "Eine kurze Frage zu Ihrer Veranstaltung Sandbox Gala",
});
const buildSatisfactionSurveyMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(SATISFACTION_SURVEY_SUBJECT_BY_LOCALE, locale), firstName = "John", campaignType = (0, organization_facing_base_1.pickForLocale)(CAMPAIGN_TYPE_BY_LOCALE, locale), campaignTypePlural = (0, organization_facing_base_1.pickForLocale)(CAMPAIGN_TYPE_PLURAL_BY_LOCALE, locale), campaignTitle = "Sandbox Gala", hasActiveOccurrence = true, surveyLink = "https://www.zeffy.com/en-US/o/campaign/sandbox-gala?showSurvey=1", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    campaignType,
    campaignTypePlural,
    campaignTitle,
    hasActiveOccurrence,
    surveyLink,
});
exports.buildSatisfactionSurveyMockData = buildSatisfactionSurveyMockData;
const buildIndividualFundraisingOutreachMockData = ({ locale = "en", subject = "Your fundraising campaign on Zeffy", firstName = "Alex", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildIndividualFundraisingOutreachMockData = buildIndividualFundraisingOutreachMockData;
const buildDesktopCompletionMockData = ({ locale = "en", subject = "Experience Zeffy at its best: switch to desktop", firstName = "John", formEditLink = "https://www.zeffy.com/en-US/o/forms", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    formEditLink,
});
exports.buildDesktopCompletionMockData = buildDesktopCompletionMockData;
const buildMailingFeedbackMockData = ({ locale = "en", subject = "How was your email experience with Zeffy?", firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildMailingFeedbackMockData = buildMailingFeedbackMockData;
const buildEmailStatsReadyMockData = ({ locale = "en", subject = "Your email stats are ready!", firstName = "John", sentEmailSubject = "Big news: our spring fundraiser is live 🌷", emailStatsUrl = "https://www.zeffy.com/en-US/o/emails/sandbox-delivery", followUpUrl = "https://www.zeffy.com/en-US/o/emails/sandbox-delivery?statuses=Delivered", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    sentEmailSubject,
    emailStatsUrl,
    followUpUrl,
});
exports.buildEmailStatsReadyMockData = buildEmailStatsReadyMockData;
